module.exports = __webpack_public_path__ + "static/media/cocacola_palco.9087a676.jpg";